module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v("Últimas publicaciones")]), _vm._v(" "), _c('ul', {
    staticClass: "blog_posts"
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', {
      key: ("post_" + (post.id))
    }, [_c('a', [_vm._v(_vm._s(post.title))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "text-transform": "uppercase"
      }
    }, [_vm._v(_vm._s(_vm.formatDate(post.createdAt)))])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82fc67ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/News.vue
// module id = 384
// module chunks = 0